import makeRequest from '../utils/makeRequest';

import * as settingsConverter from '../../../common/models/settings';

export const getSettings = async () => makeRequest({
  method: 'get',
  url: 'settings',
}).then(r => settingsConverter.parse(r));
